import { useCancelReservationMutation } from '../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useCancelReservationHandler( options?: any ) {
	const [ cancelReservation ] = useCancelReservationMutation( options )
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	return async( reservationId: number ) => {
		const result = await cancelReservation( { variables: { reservationId } } )

		if ( result.data?.cancelReservation?.success ) {
			showSuccess( `cancelReservationSuccess${Date.now()}`, result.data.cancelReservation.message )
		} else {
			showError( `cancelReservationError${Date.now()}`, result.data?.cancelReservation?.message ?? 'Sorry, an error occurred.' )
		}
	}
}
